'use strict';

var isTypedElement = require('./isTypedElement.js');
var makeNonNullableArray = require('./makeNonNullableArray.js');

/* export interface ToTypedElementArray<Inputs = unknown> {
  <T extends Inputs, Name extends Typename<T>>(
    data: MaybeArrayOf<T>,
    typename?: MaybeArrayOf<Name>,
  ): ExtractByTypename<T, Name>[];
}
 */ /**
 * Converts a {@link MaybeArrayOf} elements to an array of elements with a specific typename.
 *
 * @template T - The type of the elements in the input array.
 * @template Name - The typename of the elements in the output array.
 * @param maybeItems - The input array that may contain elements of type T.
 * @param typename - The typename of the elements to filter in the output array.
 * @returns An array of elements with the specified typename.
 */ function toTypedElementArray(maybeItems, typename) {
    const arr = makeNonNullableArray(maybeItems);
    return arr.filter((x)=>isTypedElement(x, typename));
}

module.exports = toTypedElementArray;
